var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryReportsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5334_17310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5334_17310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.90375C8.25133 8.90375 8.46483 8.816 8.6405 8.6405C8.816 8.46483 8.90375 8.25133 8.90375 8C8.90375 7.74867 8.816 7.53517 8.6405 7.3595C8.46483 7.184 8.25133 7.09625 8 7.09625C7.74867 7.09625 7.53517 7.184 7.3595 7.3595C7.184 7.53517 7.09625 7.74867 7.09625 8C7.09625 8.25133 7.184 8.46483 7.3595 8.6405C7.53517 8.816 7.74867 8.90375 8 8.90375ZM8 12.9038C8.25133 12.9038 8.46483 12.816 8.6405 12.6405C8.816 12.4648 8.90375 12.2513 8.90375 12C8.90375 11.7487 8.816 11.5352 8.6405 11.3595C8.46483 11.184 8.25133 11.0962 8 11.0962C7.74867 11.0962 7.53517 11.184 7.3595 11.3595C7.184 11.5352 7.09625 11.7487 7.09625 12C7.09625 12.2513 7.184 12.4648 7.3595 12.6405C7.53517 12.816 7.74867 12.9038 8 12.9038ZM8 16.9038C8.25133 16.9038 8.46483 16.816 8.6405 16.6405C8.816 16.4648 8.90375 16.2513 8.90375 16C8.90375 15.7487 8.816 15.5352 8.6405 15.3595C8.46483 15.184 8.25133 15.0963 8 15.0963C7.74867 15.0963 7.53517 15.184 7.3595 15.3595C7.184 15.5352 7.09625 15.7487 7.09625 16C7.09625 16.2513 7.184 16.4648 7.3595 16.6405C7.53517 16.816 7.74867 16.9038 8 16.9038ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H15.7885L20.5 8.2115V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V9H15V5H5.30775C5.21792 5 5.14417 5.02883 5.0865 5.0865C5.02883 5.14417 5 5.21792 5 5.30775V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryReportsIcon);
export default __webpack_public_path__ + "static/media/summaryReportsIcon.7dfa4277984872dd9809ddd7ba2a3fa0.svg";
export { ForwardRef as ReactComponent };